import React, { lazy, Suspense } from "react";
import { setFindMobile } from "../../store/siteSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/index.ts";

const MobileFindModal = lazy(() => import("../modal/mobile-find_modal/MobileFindModal.jsx"));
const BottomNavigationContent = lazy(() => import("./BottomNavigationContent.jsx"));

export default function BottomNavigation() {
  const dispatch = useDispatch();
  const isExtraSmall = useAppSelector((state) => state.deviceSize.isExtraSmall);
  const searchOpen = useAppSelector((state) => state.site.modals.findMobile);

  const setSearchOpen = (val) => dispatch(setFindMobile(val));

  return (
    isExtraSmall && (
      <Suspense>
        <BottomNavigationContent setSearchOpen={setSearchOpen} />
        <MobileFindModal searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
      </Suspense>
    )
  );
}
